"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dayjs_1 = __importDefault(require("dayjs"));
var AgendaOverview_1 = require("../components/organisms/AgendaOverview/AgendaOverview");
var transformAgendaOverview_1 = require("./transformAgendaOverview");
var transformClinicDetail = function (data) {
    var cancelled = data.cancelled, clinic = data.clinic, location = data.location, // eslint-disable-next-line camelcase
    school_name = data.school_name, // eslint-disable-next-line camelcase
    clinic_start_time = data.clinic_start_time, // eslint-disable-next-line camelcase
    clinic_end_time = data.clinic_end_time, // eslint-disable-next-line camelcase
    contact_person = data.contact_person, // eslint-disable-next-line camelcase
    roster_information = data.roster_information;
    var transformed = {
        school: {
            name: school_name,
            street: 'TBD',
            postal_code: 'TBD',
            city: 'TBD',
            email: 'TBD',
            phone: 'TBD',
        },
        contact: {
            group: roster_information,
            students: 'TBD',
            name: contact_person,
            email: 'TBD',
            phone: 'TBD',
        },
        clinic: {
            name: clinic.name,
            type: transformAgendaOverview_1.clinicType(clinic.type),
            sport: clinic.sport,
            cancelled: cancelled,
            date: AgendaOverview_1.formatDate(clinic_start_time),
            time: dayjs_1.default(clinic_start_time).get('hour') + ":" + dayjs_1.default(clinic_start_time).get('minutes') + " - " + dayjs_1.default(clinic_end_time).get('hour') + ":" + dayjs_1.default(clinic_end_time).get('minutes'),
            street: location,
            postal_code: 'TBD',
        },
    };
    return transformed;
};
exports.default = transformClinicDetail;
